import { SignUp } from "@clerk/react";

export default function AdminSignUp() {
  return (
    <main className="min-h-[calc(100vh-5rem)] bg-slate-50 flex items-center justify-center px-4 py-12">
      <div className="w-full flex flex-col items-center">
        <div className="text-center mb-6">
          <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">
            Create admin account
          </h1>
        </div>
        <SignUp routing="path" path="/admin/sign-up" signInUrl="/admin/sign-in" />
      </div>
    </main>
  );
}
